export const cpfMask = '###.###.###-##'
export const cnpjMask = 'NN.NNN.NNN/NNNN-##'
export const cepMask = '#####-###'
export const percentageMask = '##,## %'
export const cnhMask = '###########'
export const rgMask = '##############'
export const nationalRegMask = '###########'
export const pisMask = '###.#####.##-#'
export const yearMask = '####'
export const addressNumberMask = '#####'
export const irpfMask = '##.##.##.##.## - ##'
export const municipalTaxCodeMask = '#########'
export const pixRandomKeyMask = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'

export const phoneMask = (val) => {
  return val?.trim().length <= 10
    ? '(##) ####-#####'
    : '(##) #####-####'
}

/**
 * Dual CPF/CNPJ mask for filters and shared inputs.
 * Uses `N` (alphanumeric) instead of `#` while length ≤ 11 so the user can type
 * letters from the first character; otherwise Quasar's `#` blocks alphanumeric CNPJ.
 * Pure CPF-only fields should keep using `cpfMask` (`###...`).
 */
const paddedCpfMask = cpfMask.replace(/#/g, 'N').padEnd(cnpjMask.length, 'N')
const hasLetters = (val) => /[a-zA-Z]/.test(val ?? '')
export const cpfCnpjMask = (val) => {
  const cleaned = (val ?? '').replace(/[^a-zA-Z0-9]/g, '')
  return !hasLetters(cleaned) && cleaned.length <= 11
    ? paddedCpfMask
    : cnpjMask
}

export const barCodeMask = (val) => {
  return val?.trim().length <= 47
    ? '#####.##### #####.###### #####.###### # ##############'
    : '###########-# ###########-# ###########-# ###########-#'
}
